import React from 'react';

export type Direction = 'up' | 'down' | 'left' | 'right';

interface Props {
  onPress: (dir: Direction) => void;
  onRelease: (dir: Direction) => void;
  onConfirm: () => void;
}

const buttonBase: React.CSSProperties = {
  width: 44,
  height: 44,
  border: '1.4px solid var(--ink)',
  borderRadius: '8px 6px 8px 6px / 6px 8px 6px 8px',
  background: 'var(--paper)',
  boxShadow: '2px 3px 0 var(--ink)',
  fontWeight: 700,
  fontSize: 18,
  color: 'var(--ink)',
  cursor: 'pointer',
  fontFamily: 'inherit',
  touchAction: 'none',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const DPad: React.FC<Props> = ({ onPress, onRelease, onConfirm }) => {
  const dirHandlers = (dir: Direction) => ({
    onPointerDown: (e: React.PointerEvent) => {
      e.preventDefault();
      (e.currentTarget as HTMLElement).setPointerCapture(e.pointerId);
      onPress(dir);
    },
    onPointerUp: (e: React.PointerEvent) => {
      e.preventDefault();
      onRelease(dir);
    },
    onPointerCancel: () => onRelease(dir),
    onPointerLeave: () => onRelease(dir),
  });

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 44px)',
        gridTemplateRows: 'repeat(3, 44px)',
        gap: 6,
      }}
      aria-label="movement controls"
    >
      <span />
      <button {...dirHandlers('up')} style={buttonBase} aria-label="move up">▲</button>
      <span />
      <button {...dirHandlers('left')} style={buttonBase} aria-label="move left">◀</button>
      <button
        onPointerDown={e => { e.preventDefault(); onConfirm(); }}
        style={{ ...buttonBase, background: 'var(--w-coral)', color: '#fff' }}
        aria-label="confirm"
      >
        ●
      </button>
      <button {...dirHandlers('right')} style={buttonBase} aria-label="move right">▶</button>
      <span />
      <button {...dirHandlers('down')} style={buttonBase} aria-label="move down">▼</button>
      <span />
    </div>
  );
};

export default DPad;
